var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toolbar-block"},_vm._l((_vm.toolbarBlockItems),function(toolbarItem,index){return _c('control-panel-item',{key:index,attrs:{"panelItem":toolbarItem,"isActive":false},on:{"onClickPanelItem":_vm.onClickToolbarItem}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }